import React, { useState } from 'react';
import { useLazyGetTranslationsByCategoryQuery } from '@fiji/common/src/features/localization/localizationApi';
import { useGetUserProfileQuery } from '@fiji/common/src/features/profile/profileApi';
import { ApiEndpointType, ApiResponseType } from '@fiji/common/src/features/common/commonTypes';
import i18next from '../utils/i18n';
import { Profile } from '@fiji/common/src/types';
import englishTranslations from '@fiji/common/src/translations/english';
import { DEFAULT_LANGUAGE } from '@fiji/common/src/constants/cacheTimeout';

export const useNewCustomTranslations = (category: string, skip?: boolean): any => {
    const [isLoading, setIsLoading] = useState(false);
    const { data: userProfileData } = useGetUserProfileQuery({}, { skip }) as ApiEndpointType<ApiResponseType<Profile>>;
    const [getTranslation] = useLazyGetTranslationsByCategoryQuery<any>();
    const globalLocale = window.localStorage.getItem('globalLocale');
    const language = userProfileData?.data?.language ?? globalLocale ?? DEFAULT_LANGUAGE;
    const getCategoryTranslations = async (): Promise<void> => {
        const { data, error }: any = await getTranslation({
            body: category,
            locale: language,
        });
        if (category === 'UPCOMING_EVENTS') {
            // Adding fallback translations for Upcoming Events in case of error to avoid blank spaces in UI as this is a critical category
            i18next.addResourceBundle(
                language,
                category,
                englishTranslations[category] ?? englishTranslations.translation[category] ?? {},
                true,
                true
            );
            setIsLoading(false);
            return;
        }
        if (!error) i18next.addResourceBundle(language, category, data?.data ?? {}, true, true);
        else
            i18next.addResourceBundle(
                language,
                category,
                englishTranslations[category] ?? englishTranslations.translation[category] ?? {},
                true,
                true
            );
        setIsLoading(false);
    };

    React.useEffect(() => {
        if (!skip) {
            if (!i18next.hasResourceBundle(language, category)) {
                setIsLoading(true);
                void getCategoryTranslations();
            }
        }
    }, [skip, category, language]);

    return {
        isLoading: isLoading,
    };
};
